export default "__VITE_ASSET__C7tX4e9w__"